import {
  INotificationModel,
  INotificationListModel,
  INotificationSearchFilterModel,
  IUserNotificationSearchFilterModel,
  IUserNotificationListModel,
  INotificationSendModel,
} from "../../models";
import { SimpleServiceBase } from "../Base";
import { Observable, Observer } from "rxjs";
import { HTTP_METHOD } from "../../constants/http";
import { AxiosSubscriber } from "../AxiosSubscriber";

export class NotificationsService extends SimpleServiceBase<
  INotificationModel,
  INotificationListModel,
  number,
  INotificationSearchFilterModel
> {
  get url(): string {
    return "/Notifications";
  }

  public searchUserNotifications = (
    filter: IUserNotificationSearchFilterModel
  ): Observable<IUserNotificationListModel> =>
    new Observable(
      (observer: Observer<IUserNotificationListModel>) =>
        new AxiosSubscriber(observer, {
          data: filter,
          method: HTTP_METHOD.POST,
          url: `${this.url}/SearchUserNotifications`,
        })
    );

  public send = (filter: INotificationSendModel): Observable<void> =>
    new Observable(
      (observer: Observer<void>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.POST,
          url: `${this.url}/Send?id=${filter.Id}&rowVersion=${filter.RowVersion}`,
        })
    );
}
